//
//
//
//
//
//
//
//
//
//
//
//
//
//

import m1DiEcuComparisonQuery from '~/apollo/queries/product/m1-di-ecu-comparison'
import m1PiEcuComparisonQuery from '~/apollo/queries/product/m1-pi-ecu-comparison'

export default {
  apollo: {
    m1DiEcuComparison: {
      prefetch: true,
      query: m1DiEcuComparisonQuery
    },
    m1PiEcuComparison: {
      prefetch: true,
      query: m1PiEcuComparisonQuery
    }
  }
}
